// extracted by mini-css-extract-plugin
export var description = "how-academy-works-module--description--oCOQT";
export var wrapper = "how-academy-works-module--wrapper--CumaG";